import React from "react";
import { Route, Routes } from "react-router";
import ProtectedRoute from "./ProtectedRoute";
import HomeScreen from "../user/Screen/HomeScreen";
import InPlayScreen from "../user/Screen/exchange/member/InPlayScreen";
import CricketPage from "../user/Screen/exchange/member/CricketPage";

import PrivateCricketScreen from "../user/Screen/PrivateCricketScreen";
import PrivateSoccerScreen from "../user/Screen/PrivateSoccerScreen";
import PrivateTennisScreen from "../user/Screen/PrivateTennisScreen";
import ParentEventMatch from "../user/Screen/exchange/member/ParentEventMatch";
import MyProfileComponent from "../user/components/Accounts/MyProfileComponent";
import BetHistoryComponent from "../user/components/Accounts/BetHistoryComponent";
import AccountStatementComponent from "../user/components/Accounts/AccountStatementComponent";
import Summary from "../user/components/Accounts/BalanceOverviewComponent";
import LogOutComponent from "../user/components/Accounts/LogOutComponent";

import ProfitHistory from "../user/components/Accounts/ProfitHistory";
import AccountStatement from "../user/components/Accounts/AccountStatement";
import { Auth } from "../user/components/AuthScreen/Auth";

export default function PublicRoutes() {
  // const { hidePublicRoutes } = useSelector((state) => state?.auth);
  const hidePublicRoutes = false;
  // http://localhost:3000/game-list/event/4/1104111431
  return (
    <Routes>
      <Route element={<ProtectedRoute hidePublic={hidePublicRoutes} />}>
        <Route path="/" element={<HomeScreen />} />
        <Route path="/login" element={<Auth type={"login"} />} />
        <Route path="/signup" element={<Auth type={"sign up"} />} />
        <Route path="/in-play" element={<InPlayScreen />} />
        <Route path="/multi-markets" element={<>Multi markets</>} />
        <Route path="/cricket" element={<PrivateCricketScreen />} />
        <Route path="/soccer" element={<PrivateSoccerScreen />} />
        <Route path="/tennis" element={<PrivateTennisScreen />} />
        <Route path="/my-profile" element={<MyProfileComponent />} />
        <Route path="/bet-history" element={<BetHistoryComponent />} />
        <Route path="/profit-loss" element={<ProfitHistory />} />
        <Route path="/account-statement" element={<AccountStatement />} />
        <Route path="/balance-overview" element={<Summary />} />
        <Route path="/log-out" element={<LogOutComponent />} />

        {/* //admin roiutes  */}

        <Route
          path="/game-list/event/:eventId/:gameId"
          element={<ParentEventMatch />}
        />
      </Route>
    </Routes>
  );
}